import './Drawcanvas.css';
import Messages from './Messages.js';
import ChatInput from './ChatInput.js';
import { useSelector } from 'react-redux'

function Chat(props) {
  const gameState = useSelector((state) => ({
    messages: state.gameState.messages
  }));
  const socket = props.socket;

  if (gameState.messages && gameState.messages.length > 0) {
    return (
      <div className="chat relative bg-gray-100 h-full shadow shadow-2xl shadow-inner w-full pb-8 pt-2 px-4 md:px-4 md:pb-20 md:pt-2 sm:p-5 text-base text-gray-700 xl:text-lg text-sm md:h-full bottom-0 rounded-sm flex-1">
          <div className='h-full relative' id='messages'>
            <Messages/>
          </div>
        <div className="absolute inset-x-0 bottom-0 mx-2">
          <ChatInput socket={socket}/>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className="chat relative bg-gray-100 h-full shadow shadow-2xl shadow-inner w-full pb-8 pt-2 px-4 md:px-4 md:pb-20 md:pt-2 sm:p-5 text-base text-gray-700 xl:text-lg text-sm md:h-full bottom-0 rounded-sm flex-1">
        <div className="absolute inset-x-0 bottom-0">
          <ChatInput socket={socket}/>
        </div>
      </div>
    );
  }
  
}

export default Chat;
